import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';

const IOS_APP_STORE_URL = 'https://apps.apple.com/us/app/saverly-kroger-meals/id6756591268';
const ANDROID_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.saverly.app&hl=en_US';
const DOWNLOAD_FALLBACK_URL = '/download';

function getPlatformFromUserAgent() {
  const ua = navigator.userAgent || '';
  if (/android/i.test(ua)) return 'android';
  if (/iphone|ipad|ipod/i.test(ua)) return 'ios';
  return 'web';
}

function getConvexSiteBaseUrl() {
  const explicit = process.env.REACT_APP_CONVEX_SITE_URL || '';
  if (explicit) return explicit.replace(/\/+$/, '');

  const convexCloud = process.env.REACT_APP_CONVEX_URL || '';
  if (!convexCloud) return '';
  return convexCloud.replace('.convex.cloud', '.convex.site').replace(/\/+$/, '');
}

function getRedirectTarget(platform) {
  if (platform === 'ios') {
    return { target: 'app_store', url: IOS_APP_STORE_URL };
  }
  if (platform === 'android') {
    return { target: 'play_store', url: ANDROID_PLAY_URL };
  }
  return { target: 'download_page', url: DOWNLOAD_FALLBACK_URL };
}

export default function PromoRedirectPage() {
  const { campaignCode = '' } = useParams();
  const platform = useMemo(getPlatformFromUserAgent, []);
  const redirect = useMemo(() => getRedirectTarget(platform), [platform]);

  useEffect(() => {
    const convexSiteBaseUrl = getConvexSiteBaseUrl();
    const payload = {
      campaignCode,
      platform,
      target: redirect.target,
      targetUrl: redirect.url,
      pathname: window.location.pathname,
      queryString: window.location.search || '',
      referrer: document.referrer || '',
      userAgent: navigator.userAgent || '',
    };

    const logPromise = convexSiteBaseUrl
      ? fetch(`${convexSiteBaseUrl}/marketing/redirect-hit`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          keepalive: true,
        }).catch(() => null)
      : Promise.resolve(null);

    const timeoutPromise = new Promise((resolve) => setTimeout(resolve, 250));

    Promise.race([logPromise, timeoutPromise]).finally(() => {
      window.location.replace(redirect.url);
    });
  }, [campaignCode, platform, redirect.target, redirect.url]);

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6 text-center">
      <h1 className="text-2xl font-semibold text-gray-900 mb-3">Redirecting to Saverly...</h1>
      <p className="text-gray-600 mb-6">
        Taking you to the right app store now.
      </p>
      <a
        href={redirect.url}
        className="w-full max-w-sm rounded-lg bg-saverly-primary text-white py-3 font-semibold"
      >
        Continue
      </a>
    </div>
  );
}

